import React ,{useEffect} from "react";
import { Grid, Typography, InputLabel,TextField } from "@material-ui/core";
import { Accordion, Card } from "react-bootstrap";
import { InputField, DatePickerField, PhoneInput, SelectField } from "../FormFields";
import {
    makeStyles,
    Snackbar,
    SnackbarContent,
} from "@material-ui/core";
import clsx from "clsx";
import green from "material-ui/colors/green";

export default function LoginFrom(props) {
    const [alertOpen, setAlertOpen] = React.useState(false);
    function handleClose(event, reason) {
        setAlertOpen(false);
    }
  
    const useStyles = makeStyles((theme) => ({
        success: {
            backgroundColor: green[600],
        },
        
    }));

    function MySnackbarContentWrapper(props) {
        const classes = useStyles();
        const { className, message, onClose, variant, ...other } = props;

        return (
            <SnackbarContent
                className={clsx(classes[variant], className)}
                aria-describedby="client-snackbar"
                message={
                    <span id="client-snackbar" className={classes.message}>
                        {message}
                    </span>
                }
                {...other}
            />
        );
    }
    const {
        formField: {
            email,
            password,
            cofirm_password
        },
      
    } = props;
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("userData"))
        // console.log(props.userinfo,"userData")
        props.setFieldValue("email",props.userinfo.mail)
    },[])

    const copyurl = () => {
        navigator.clipboard.writeText("https://ccmode.diazoom.com/")
        // alert("Copied to clipboard")
        setAlertOpen(true);
    }
    return (
        <React.Fragment>
            <Accordion className="ccmode_accordion my-10" defaultActiveKey="4">
                <Accordion.Toggle className="mb-10" as={Card.Header} eventKey="4" key="4">
                    {props.language.SETTING_CCMODE_LOGIN_SETTING} 
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="4">
                    <Grid container justify="center" alignItems="center" spacing={3} className="mb-10">
                        <Grid item xs={12} md={7}>
                            <InputField
                                name={email.name}
                                label={props.language.CCMODE_SETUP_LOGIN_FORM_EMAIL}
                                fullWidth
                                disabled={true}
                                inputProps={{
                                    style: { color: 'rgb(50, 50, 50)' }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <InputField
                                name={password.name}
                                label={props.language.CCMODE_SETUP_LOGIN_FORM_PASSWORD}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <InputField
                                name={cofirm_password.name}
                                label={props.language.CCMODE_SETUP_LOGIN_FORM_CPASSWORD}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={7}>
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    {props.language.SETTING_CCMODE_ACCESS_LINK}
                                </div>
                                <div className="col-md-6 d-flex justify-content-center align-items-center">
                                    <div class="form-group mb-0 w-100">
                                        <div class="input-group">
                                            <input type="text" value="https://ccmode.diazoom.com/" disabled id="copyurl" className="form-control disabled m-0"/> 
                                            <div class="input-group-append">
                                                <span class="input-group-text">
                                                    <i className="fa fa-copy cursor-pointer" onClick={() => copyurl()}></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Accordion.Collapse>
            </Accordion>
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                open={alertOpen}
                autoHideDuration={2000}
                onClose={handleClose}
            >
                <MySnackbarContentWrapper
                    onClose={handleClose}
                    variant="success"
                    message={`Copied to Clipboard`}
                />
            </Snackbar>
        </React.Fragment>
    );
}
